import React, { useEffect } from "react";
import { useMiniGameAuth } from "@pages/Events/MiniGame/store";
import ComponentRequest from "./ComponentRequest";

export default function RequestPiece() {
  const { isAuthenticated, requireLogin } = useMiniGameAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      requireLogin();
    }
  }, [isAuthenticated, requireLogin]);

  if (!isAuthenticated) {
    return null;
  }

  return <ComponentRequest />;
}
